webpackJsonp([114276838955818,60335399758886],{

/***/ 237:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 317:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(325);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(237);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 47:
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(49);
	var isArguments = __webpack_require__(48);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ 48:
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ 49:
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ 52:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(57);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(47);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(53);
	
	var _HelmetConstants = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 16:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(4);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 57:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(2);
	var React__default = _interopDefault(React);
	var ExecutionEnvironment = _interopDefault(__webpack_require__(60));
	var shallowEqual = _interopDefault(__webpack_require__(64));
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !shallowEqual(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return React__default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(React.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = ExecutionEnvironment.canUseDOM;
	
	
	    return SideEffect;
	  };
	}
	
	module.exports = withSideEffect;


/***/ }),

/***/ 324:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(80);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _logo = __webpack_require__(551);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Navbar = function Navbar() {
	  return _react2.default.createElement(
	    'nav',
	    { className: 'navbar' },
	    _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'navbar-brand' },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/', className: 'navbar-item' },
	          _react2.default.createElement('img', { src: _logo2.default, alt: 'Wind Swell' })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'navbar-end' },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: 'navbar-item has-text-centered-touch', to: '/about' },
	          'About'
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: 'navbar-item has-text-centered-touch', to: '/contact' },
	          'Contact'
	        )
	      )
	    )
	  );
	};
	
	exports.default = Navbar;
	module.exports = exports['default'];

/***/ }),

/***/ 551:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 531:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 325:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(52);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Navbar = __webpack_require__(324);
	
	var _Navbar2 = _interopRequireDefault(_Navbar);
	
	__webpack_require__(531);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TemplateWrapper = function TemplateWrapper(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    'section',
	    { className: 'hero' },
	    _react2.default.createElement(_reactHelmet2.default, { title: 'Wind Swell' }),
	    _react2.default.createElement(
	      'div',
	      { className: 'hero-head' },
	      _react2.default.createElement(_Navbar2.default, null)
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'hero-body' },
	      children()
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'hero-foot' },
	      _react2.default.createElement(
	        'div',
	        { className: 'copyright is-size-7 has-text-light has-text-right is-italic has-text-weight-light' },
	        '\xA9 Copyright ',
	        new Date().getFullYear(),
	        ' Will Simons. All rights reserved.'
	      )
	    )
	  );
	};
	
	TemplateWrapper.propTypes = {
	  children: _propTypes2.default.func
	};
	
	exports.default = TemplateWrapper;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-28281720d426ff0e6209.js